import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'subsubjectSearchPipe', pure: false,
    standalone: false
})
export class SubsubjectSearch implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(subsubject => {
        if (subsubject.name) {
          return subsubject.name.search(searchText) !== -1 || subsubject.customName.search(searchText) !== -1;
        }
      });
    }
  }
}
